import { render, staticRenderFns } from "./AndCriteria.vue?vue&type=template&id=1b0a1726"
import script from "./AndCriteria.vue?vue&type=script&lang=js"
export * from "./AndCriteria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports